import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SelectSearch from 'react-select-search';
import { SlideDown } from 'react-slidedown';
import { whiteSecondary, blackPrimary } from '../../styles/variables.scss';
import { ARROW_DOWN } from '../../constants/iconNames';
import Icon from '../../icons';
import './simple-dropdown.scss';
function SimpleDropdown({ isWhite, values, title, onChange, customClass }) {
    const [isOpen, setIsOpen] = useState(false);
    return (_jsxs("div", { className: `${isWhite ? 'simple-dropdown--white ' : 'simple-dropdown '}${customClass}`, children: [_jsxs("button", { onClick: () => setIsOpen(!isOpen), children: [_jsx("span", { children: title }), _jsx("span", { className: isOpen ? 'rotate-up' : 'rotate-down', children: _jsx(Icon, { stroke: isWhite ? blackPrimary : whiteSecondary, name: ARROW_DOWN }) })] }), _jsx(SlideDown, { className: "slidedown", closed: !isOpen, transitionOnAppear: true, children: _jsx(SelectSearch, { autofocus: true, handleClickOutside: () => { }, onChange: e => {
                        onChange(e);
                        setIsOpen(!isOpen);
                    }, options: values, search: false }) })] }));
}
SimpleDropdown.propTypes = {
    isWhite: PropTypes.bool,
    values: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.any,
        value: PropTypes.any,
    })).isRequired,
    title: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    customClass: PropTypes.string,
};
SimpleDropdown.defaultProps = {
    isWhite: false,
    customClass: '',
};
export default SimpleDropdown;
